export const GET_KYP_DATA = "GET_KYP_DATA";
export const GET_KYP_DATA_SUCCESS = "GET_KYP_DATA_SUCCESS";
export const GET_KYP_DATA_FAILED = "GET_KYP_DATA_FAILED";

export const DOWNLOAD_KYP_CSV = "DOWNLOAD_KYP_CSV";
export const DOWNLOAD_KYP_CSV_SUCCESS = "DOWNLOAD_KYP_CSV_SUCCESS";
export const DOWNLOAD_KYP_CSV_FAILED = "DOWNLOAD_KYP_CSV_FAILED";
export const CLEAR_KYP_MESSAGE = "CLEAR_KYP_MESSAGE";

export const GET_AUTOMATED_KYP_LEADS = "GET_AUTOMATED_KYP_LEADS";
export const GET_AUTOMATED_KYP_LEADS_SUCCESS = "GET_AUTOMATED_KYP_LEADS_SUCCESS";
export const GET_AUTOMATED_KYP_LEADS_FAILED = "GET_AUTOMATED_KYP_LEADS_FAILED";
